// SPDX-License-Identifier: AGPL-3.0-or-later
import type { Dataset } from '../types';
import { esc } from '../format';
import { buildInsights } from '../analysis';
import { navigate } from '../main';

export function renderInsights(root: HTMLElement, data: Dataset): void {
  const insights = buildInsights(data);
  root.innerHTML = `
    <div class="view-head">
      <h2>What the data shows</h2>
      <p>Findings pulled automatically from the numbers — the biggest closures, the hardest-hit places, and where the safety net is thinnest. Each links to the view it came from.</p>
    </div>
    <div class="insight-grid">
      ${insights.map((ins, i) => `
        <div class="insight ${ins.severity}">
          <h3>${esc(ins.title)}</h3>
          <p>${esc(ins.body)}</p>
          ${ins.link ? `<button data-i="${i}">${esc(ins.link.label)} →</button>` : ''}
        </div>`).join('')}
    </div>
  `;
  root.querySelectorAll<HTMLButtonElement>('[data-i]').forEach((b) =>
    b.addEventListener('click', () => {
      const ins = insights[+b.dataset.i!];
      if (ins.link) navigate({ view: ins.link.view as never, region: ins.link.region, bank: ins.link.bank, filter: ins.link.filter });
    }),
  );
}
